module.exports = __webpack_public_path__ + "platform/static/media/learn.83a01228.svg";